module.exports = __webpack_public_path__ + "static/media/vctr-expand.1e286913.svg";